import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'
import { TransitionLink } from '@/components/generals/transition-link'
import { siteConfig, QUOTE_PATH } from '@/constants/site'

export const EMERGENCY_BAR_HEIGHT = 36

export const EmergencyBar: FC = (): ReactNode => {
    return (
        <div className='h-9 bg-ink-deep text-cream'>
            <Container className='flex h-full items-center justify-between gap-4 text-[12.5px] sm:text-[13px]'>
                <p className='flex min-w-0 items-center gap-2.5'>
                    <span className='relative flex size-2 shrink-0' aria-hidden='true'>
                        <span className='absolute inset-0 rounded-full bg-ember animate-live' />
                        <span className='relative size-2 rounded-full bg-ember' />
                    </span>

                    <span className='truncate font-medium'>
                        Broken spring, or a door that won't close?
                    </span>

                    <span className='hidden truncate text-cream/55 lg:inline'>
                        Our emergency line answers until {siteConfig.emergencyUntil} tonight.
                    </span>
                </p>

                <div className='flex shrink-0 items-center gap-5'>
                    <a
                        href={siteConfig.phoneHref}
                        className='font-mono text-[12px] tracking-wide text-cream transition-colors hover:text-ember-soft'
                    >
                        {siteConfig.phone}
                    </a>

                    <TransitionLink
                        href={`${QUOTE_PATH}?service=emergency-repair&entry=text_back`}
                        className='hidden text-cream/60 underline-offset-4 transition-colors hover:text-cream hover:underline md:inline'
                    >
                        Prefer a text back?
                    </TransitionLink>
                </div>
            </Container>
        </div>
    )
}
